<template>
  <div>
    <answer-render ref="answer" :config="config" :cvtLang="cvtLang">
      <div class="input-wrapper" slot="body">
        <FormItem prop="value" v-if="!config.screenCode" ref="textContent" :rules="rules">
          <Input
            class="textarea wyb"
            v-model="config.value"
            :placeholder="config.displayPlaceholder"
            type="textarea"
            :rows="config.answerConfig.inputSize"
            :maxlength="1000"
            @input="inputChange"
            @on-focus="inputFocus"
            @on-blur="inputBlur"
          />
        </FormItem>
        <FormItem prop="value" v-else :rules="rules">
          <el-date-picker
            v-if="config.screenCode === 'birthday'"
            v-model="config.value"
            type="date"
            :editable="false"
            value-format="yyyyMMdd"
            format="yyyy-MM-dd"
            :picker-options="pickeryyyyMMddOption"
            :placeholder="$t('choiceYearMonthDay')"
          ></el-date-picker>
          <input v-else-if="config.screenCode === 'email'" class="input-answer" v-model="config.value" type="email">
          <input v-else-if="config.screenCode === 'phone1'" class="input-answer" v-model="config.value" type="number">
          <input v-else-if="config.screenCode === 'idCard'" class="input-answer idcard-answer" v-model="config.value" type="text">
          <Input
            v-else
            class="textarea wyb"
            v-model="config.value"
            type="textarea"
            :row="{minRows: 9,maxRows: 9}"
            :maxlength="1000"
          />
        </FormItem>
      </div>
    </answer-render>
  </div>
</template>

<script>
import answerValidate from './answerValidate'
import { validCertNoOrMobile } from '@/service/survey'
import { mapState } from 'vuex'
export default {
  name: 'TitleBoxAnswer',
  props: ['config'],
  data () {
    return {
      validStatus: 0,
      rules: [
        {
          validator: (rule, value, callback) => {
            const errors = answerValidate.validate.bind(this.config)(this).errors
            if (errors.length) {
              return callback(errors)
            }
            return callback()
          }
        }
      ]
    }
  },
  components: {
  },
  watch: {},
  computed: {
    ...mapState({
      lang: ({Question}) => Question.lang,
      surveyInfoLang: ({Question}) => Question.surveyInfoLang, // 基础语言配置（提示文字、按钮、题型）
      langMap: ({Question}) => Question.langMap,
      surveyInfo: ({Question}) => Question.surveyInfo
    }),
    pickeryyyyMMddOption () {
      return {
        disabledDate (time) {
          const currentStr = `${time.getFullYear()}${(
            time.getMonth() + ''
          ).padStart(2, '0')}${(time.getDate() + '').padStart(2, '0')}`
          return !(currentStr >= 19000101 && currentStr <= 20991231)
        }
      }
    },
    validType() {
      let type = null
      const {mediaQuType} = this.config
      if (mediaQuType === 'phone1') {
        // 手机
        type = 1
      } else if (mediaQuType === 'idCard') {
        // 身份证
        type = 2
      }
      return type
    }
  },
  methods: {
    // 验证手机/身份证等唯一性
    async validUniqueness() {
      const {phoneCheck} = this.config.answerConfig
      const res = await validCertNoOrMobile({
        type: this.validType,
        value: this.config.value,
        surveyMainId: this.surveyInfo.surveyMainId
      })
      if (res.code === 220019) {
        // 手机号前n位重复
        this.config.tipsMsg = this.cvtLang('tipsMobileUnique', this.config.tipsMobileUnique)
        answerValidate.validate.bind(this.config)(this)
      } else if (res.code === 220018) {
        this.config.tipsMsg = this.cvtLang('tipsIDUnique', this.config.tipsIDUnique)
      } else {
        if (phoneCheck === '1') {
          // 校验手机前缀是否重复
          this.validMobilePrefix()
        }
      }
      this.handleValidate()
    },
    // 验证手机号前缀
    async validMobilePrefix() {
      const res = await validCertNoOrMobile({
        type: 1,
        value: this.config.value.substr(0, this.config.answerConfig.phonePrefix),
        surveyMainId: this.surveyInfo.surveyMainId
      })
      if (res.code === 220020) {
        // 手机号前n位重复
        this.config.tipsMsg = this.cvtLang('tipsPrefixUnique', this.config.tipsPrefixUnique).replace('${n}', this.config.answerConfig.phonePrefix)
      }
      this.handleValidate()
    },
    syncValid() {
      const {uniqueInd, phoneCheck} = this.config.answerConfig
      if (uniqueInd === '1' && ['idCard', 'phone1'].includes(this.config.mediaQuType)) {
        // 唯一性校验
        this.validUniqueness()
      } else {
        if (phoneCheck === '1') {
          // 校验手机前缀是否重复
          this.validMobilePrefix()
        }
      }
    },
    inputFocus() {
      if (window._env_ === 'android') {
        // android app下
      } else {
        if (this.handleValidate()) {
          this.validStatus = 1
          if (this.$route.query.view !== 'preview') {
            this.syncValid()
          }
        } else {
          this.validStatus = 0
        }
      }
    },
    inputBlur() {
      if (window._env_ === 'android') {
        // android app下
      } else {
        if (!this.validStatus && this.handleValidate()) {
          if (this.$route.query.view !== 'preview') {
            this.syncValid()
          }
        }
      }
    },
    handleValidate() {
      if (answerValidate) {
        const result = answerValidate.validate.bind(this.config)(this).result
        if (!result) {
          // 校验文件
          const validate = this.$refs.answer.$refs.answerValidate
          validate && validate.validate()
        }
        return result
      }
    },
    ismobile () {
      const u = navigator.userAgent
      if (/AppleWebKit.*Mobile/i.test(navigator.userAgent) || (/MIDP|SymbianOS|NOKIA|SAMSUNG|LG|NEC|TCL|Alcatel|BIRD|DBTEL|Dopod|PHILIPS|HAIER|LENOVO|MOT-|Nokia|SonyEricsson|SIE-|Amoi|ZTE/.test(navigator.userAgent))) {
        if (window.location.href.indexOf('?mobile') < 0) {
          try {
            if (/iPhone|mac|iPod|iPad/i.test(navigator.userAgent)) {
              return '0'
            } else {
              return '1'
            }
          } catch (e) {}
        }
      } else if (u.indexOf('iPad') > -1) {
        return '0'
      } else {
        return '1'
      }
    },
    inputChange() {
      this.config.tipsMsg = ''
      sessionStorage.setItem('allOrderByIdStash', this.config.allOrderById)
      
      if (window._env_ === 'android') {
        // android app下
      } else {
        if (this.handleValidate()) {
          this.validStatus = 1
          if (this.$route.query.view !== 'preview') {
            this.syncValid()
          }
        } else {
          this.validStatus = 0
        }
      }
    },
    // TODO 引用/继承
    isOrigin () {
      return this.lang === 'origin'
    },
    // TODO 引用/继承
    cvtLang: function (id, title) {
      if (this.isOrigin()) {
        return title
      }
      const {lang, langMap} = this
      const key = `${id}_${lang}`
      const value = langMap[key]
      if (!value) {
        this.$set(langMap, key, '')
      }
      return langMap[key]
    }
  },
  created () {
    // init tipsMsg
    this.$set(this.config, 'tipsMsg', '')
  },
  mounted () {
    if (!this.config.screenCode && this.ismobile() === '0') {
      document.documentElement.addEventListener('focusout', () => {
        window.scroll(0, 0)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.input-wrapper {
  .input-answer {
    height: 64px;
    padding: 0 20px;
    line-height: 64px;
    width: 320px;
    outline: none;
    border: 1px solid #C2C2C2;
    border-radius: 4px;

    font-size: 28px;
    font-weight: 500;
  }
  .ivu-input-wrapper {
    margin-top: 40px !important;
  }
}
.answer-pc {
  .input-wrapper {
    .ivu-input-wrapper {
      margin-top: 10px !important;
    }
    .input-answer {
      height: 32px;
      padding: 0 10px;
      line-height: 32px;
      width: 160px;
      border-radius: 2px;
      font-size: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/editor/TitleBox/TitleBoxAnswer.vue